'use strict';

const removeDuplicatesFromArray = require('../../modules/util/removeDuplicatesFromArray'),
    ajaxUrl = require('../../modules/util/ajaxUrl'),
    ajax = require('../../modules/ajax'),
    ritualsStyles = require('../../rituals-styles'),
    Promise = require('promise'),
    flyout = require('../../flyout'),
    formHelpers = require('../../rituals-form-helper'),
    Resources = window.Resources || {},
    damHelper = require('../../dam/dam-helper'),
    gtm = require('../../modules/google').tagManager;

const genericFlyout = '.js-generic-flyout';
let timer;

function initEvents(){
    // on click in the notification PDP button and the close icon in the flyout, open or close
    $(document).off('click', '.js-out-of-stock-btn');
    $(document).on('click', '.js-out-of-stock-btn', function(e){
        e.preventDefault();
        e.stopPropagation();
        const $this = $(this);
        const $adventOutOfStock = $('.js-advent-out-of-stock');
        const source = $this.data('sticky-type');
        const popup = $this.parents('.js-popup-generic');
        // if click comes from packshot out of stock button, get the product
        if ($adventOutOfStock.length){
            getProductBar($('.js-advent-out-of-stock-pid').val());
        }
        if (source === 'showbar') {
            getProductBar($this.closest('form').find('[name=pid]').val());
        } else if (source === 'elixir'){
            const data = getElixirsOutOfStockData($this);
            updateElixirStickyValues(data);
            toggleFlyout();
        } else {
            toggleFlyout();
        }

        if (popup.length) {
            popup.dialog('close');
        }
    });

    //enable/disable the button depending on validation of the email field
    $(document).on('keyup', '.js-stock-notification-email', function(){
        const $form = $(this).closest('form');
        const isValid = $form.validate().checkForm();

        if ($('.js-stock-notification-email')[0].value.length === 0){
            // if input is empty, clean validation and start over
            $form.validate().resetForm();
            $('.js-stock-notification-email').next('.js-validator-error').remove();
        }

        if (isValid){
            $('.js-stock-notification-submit-btn').removeClass('btn--disabled');
        } else {
            $('.js-stock-notification-submit-btn').addClass('btn--disabled');
        }
    });

    //if the field has a validation error, validate on keydown
    $(document).on('keydown', '.js-stock-notification-email.error', function(){
        $(this).valid();
    });

    $(document).off('click', '.js-stock-notification-submit-btn');
    $(document).on('click', '.js-stock-notification-submit-btn', requestBackInStockNotification);
}

function getProductBar(pid) {
    if (!pid) {
        return;
    }
    // empty the flyout
    $('.js-alt-stock-notification-flyout').empty();

    // get new one
    ajax.load({
        url: Urls.getStockNotificationBar,
        data: {pid: pid, source: 'showbar'},
        target: $('.js-alt-stock-notification-flyout'),
        callback: function () {
            // toggle packshot sticky after a tiny timeout
            // fixes the choppy 'open' animation
            setTimeout(function(){
                toggleFlyout();
            }, 10);

            ritualsStyles.initInputStyles();
        }
    });
}

function toggleFlyout(){
    $(genericFlyout).addClass('flyout-out-of-stock');
    const flyoutHtml = $('.js-out-of-stock-wrapper').html();

    const options = {
        open: function() {
            formHelpers.init();
        }
    };

    flyout.loadFromHtml(flyoutHtml, options);
    damHelper.updateImages($('.js-flyout-out-of-stock'));
    window.clearTimeout(timer);
}

function requestBackInStockNotification(evt) {
    evt.preventDefault();

    const emailInput = $(this).parent().find('.js-stock-notification-email');
    const email = emailInput.val();

    if (!emailInput.valid() || !email) {
        return;
    }

    const productId = $('input#hdn_product_id').val();
    const gtmData = $('input#gtm-data').val();
    if (gtmData) {
        gtm.pushDataLayerEvent(JSON.parse(gtmData));
    }

    const $notificationButton = $('.js-stock-notification-submit-btn');
    $notificationButton.addClass('button-loading');
    $notificationButton.find('.js-spinner-general').addClass('spinner-visible');

    Promise.resolve($.ajax({
        type: 'POST',
        url: ajaxUrl(Urls.requestStockNotification),
        contentType: 'application/json',
        dataType: 'html',
        data: JSON.stringify({
            email: email,
            productId: productId
        })
    })).then(function (response) {
        const $outOfStockResponseContainer = $('.js-out-of-stock-response-container', '.js-flyout-container');
        const $outOfStockForm = $('.js-out-of-stock-form', '.js-flyout-container');
        $outOfStockResponseContainer.html(response);
        $outOfStockForm.addClass('js-submitted').hide();
        $outOfStockResponseContainer.removeClass('hide');
    });
}

/**
 * Resets the "notify me when back in stock" form.
 * Updates the product ID used, but leaves the email.
 * Useful when changing product variant (e.g. clothing size)
 * @param {string} productId The product to which a back in stock notification should be requested
 */
function resetForm(productId){
    $('input#hdn_product_id').val(productId);
    flyout.closeFlyouts();
    $('.js-out-of-stock-response-container').addClass('hide');
    $('.js-out-of-stock-response-container').empty();
    $('.js-out-of-stock-form').show();
}

const getElixirsOutOfStockData = function(button){

    const selected = button.parents('.js-product-details-content').find('option.js-out-of-stock-option:selected');
    if (!selected.length) {
        return [];
    }
    const data = $.map(selected, function(el){
        el = $(el);
        return {id: el.attr('value'),name:el.data('value')};
    });
    return removeDuplicatesFromArray(data, 'id');
};

const updateElixirStickyValues = function(data){
    if (!data || !data.length) {
        return;
    }

    const elixirStickyBar = $('.js-flyout-out-of-stock.js-elixir-out-of-stock');
    if (!elixirStickyBar.length){
        const elixirStickyBar = $('.js-flyout-out-of-stock');
        elixirStickyBar.attr('data-sticky-source','elixir').addClass('js-elixir-out-of-stock');
        elixirStickyBar.find('.image-container').remove();
    }

    let message;
    if (data.length === 1){
        $('input#hdn_product_id').val(data[0].id);
        message = String.format(Resources.ELIXIR_OUT_OF_STOCK,data[0].name);
    } else if (data.length === 2) {
        const elixirsIds = data.map(function(el){
            return el.id;
        });

        $('input#hdn_product_id').val(elixirsIds.join('|'));
        message = String.format(Resources.BOTH_ELIXIRS_OUT_OF_STOCK, data[0].name, data[1].name);
    }
    elixirStickyBar.find('div.message').html(message);
};

/**
 * @function
 * @description Binds the click event to the "Keep me posted" button
 */
module.exports = {
    init: initEvents,
    resetForm: resetForm
};
